const DRAFT_PREFIX = "muqalab_registration_draft_v1_season_";
const MAX_AGE_MS = 14 * 24 * 60 * 60 * 1000; // 14 days

const draftKey = (seasonId) => `${DRAFT_PREFIX}${seasonId}`;

export function saveDraft(seasonId, formData) {
  if (!seasonId) return;
  try {
    localStorage.setItem(
      draftKey(seasonId),
      JSON.stringify({ savedAt: Date.now(), formData }),
    );
  } catch (err) {
    // localStorage can throw in private browsing / when full — saving a draft
    // is a nice-to-have, it should never break registration itself
    console.warn("Failed to save registration draft:", err);
  }
}

export function loadDraft(seasonId) {
  if (!seasonId) return null;
  try {
    const raw = localStorage.getItem(draftKey(seasonId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.savedAt || !parsed?.formData) return null;
    if (Date.now() - parsed.savedAt > MAX_AGE_MS) {
      localStorage.removeItem(draftKey(seasonId));
      return null;
    }
    return parsed;
  } catch (err) {
    console.warn("Failed to load registration draft:", err);
    return null;
  }
}

export function clearDraft(seasonId) {
  if (!seasonId) return;
  try {
    localStorage.removeItem(draftKey(seasonId));
  } catch (err) {
    console.warn("Failed to clear registration draft:", err);
  }
}

// Don't bother offering/saving a draft that's really just the untouched default form
export function isFormDataBlank(formData) {
  if (!formData) return true;
  const noTeam = !formData.teamName.trim();
  const noCaptain =
    !formData.captainName.trim() && !formData.captainEmail.trim();
  const noPlayers = formData.players.every((p) => !p.name.trim());
  return noTeam && noCaptain && noPlayers;
}
